import { render } from "./salesbycategory.vue?vue&type=template&id=55f0bbf2&scoped=true"
import script from "./salesbycategory.vue?vue&type=script&lang=js"
export * from "./salesbycategory.vue?vue&type=script&lang=js"

import "./salesbycategory.vue?vue&type=style&index=0&id=55f0bbf2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f0bbf2"]])

export default __exports__